<div class="flx-modal" role="dialog" aria-modal="true">
    <div class="flx-modal__header">
        <div class="with-desc">
            <h2>{{ translate?.setup.users.access.sections.sec9.singular || 'Manage Integrations' }}</h2>
            <span class="sub">Manage integrations for this user</span>
        </div>
        <button class="icon-btn" aria-label="Close" [pTooltip]="translate?.general.buttons.close.singular"
            (click)="modalRef.hide()">
            <i class="fa-regular fa-xmark"></i>
        </button>
    </div>
    <div class="flx-modal__body">
        <div class="mp-toggle-list m-0" *ngIf="hasAnyIntegrationEnabled">
            <!-- Google -->
            <section class="mp-subpanel mp-row" *ngIf="googleEnable?.enabled">
                <div class="mp-subhead-sub mp-subhead--inline">
                    <div class="flex-align-center gap-2">
                        <img src="../../../../assets/svg/google-calendar.svg" alt="Google Calendar logo" class="head-img">
                        <div>
                            <div class="title">{{translate?.setup.users.users.fields.integratesGoogle.singular}}</div>
                            <p class="sub">{{translate?.setup.users.users.descriptions.connectToGoogleCalendar.singular}}</p>
                        </div>
                    </div>
                    <div class="mp-toggle-meta">
                        <div class="mp-subhead-toggle">
                            <p-button
                                *ngIf="!googleCalenderConnected"
                                styleClass="text-nowrap connect"
                                [disabled]="!canConnectGoogleCalender"
                                [label]="translate?.general.buttons.connect.singular"
                                (onClick)="connectGoogleCalender()"></p-button>
                            <p-button
                                *ngIf="googleCalenderConnected"
                                styleClass="text-nowrap connect p-button-danger"
                                [disabled]="!canConnectGoogleCalender"
                                [label]="translate?.general.buttons.disconnect.singular"
                                (onClick)="disConnectGoogleCalender()"></p-button>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Microsoft -->
            <section class="mp-subpanel mp-row" *ngIf="microsoftEnable?.enabled">
                <div class="mp-subhead-sub mp-subhead--inline">
                    <div class="flex-align-center gap-2">
                        <img src="../../../../assets/svg/office365.svg" alt="Office365 logo" class="head-img">
                        <div>
                            <div class="title">{{translate?.setup.users.users.fields.integratesMicrosoft365.singular}}</div>
                            <p class="sub">{{translate?.setup.users.users.descriptions.connectToMicrosoftOutlookCalendar.singular}}</p>
                        </div>
                    </div>
                    <div class="mp-toggle-meta">
                        <div class="mp-subhead-toggle">
                            <p-button
                                *ngIf="!microsoftCalenderConnected"
                                styleClass="text-nowrap connect"
                                [disabled]="!canConnectGoogleCalender"
                                [label]="translate?.general.buttons.connect.singular"
                                (onClick)="connectMicrosoftCalender()"></p-button>
                            <p-button
                                *ngIf="microsoftCalenderConnected"
                                styleClass="text-nowrap connect p-button-danger"
                                [disabled]="!canConnectGoogleCalender"
                                [label]="translate?.general.buttons.disconnect.singular"
                                (onClick)="disConnectMicrosoftCalender()"></p-button>
                        </div>
                    </div>
                </div>
            </section>

            <!-- Calendly -->
            <section class="mp-subpanel mp-row" *ngIf="calendlyEnable?.enabled">
                <div class="mp-subhead-sub mp-subhead--inline">
                    <div class="flex-align-center gap-2">
                        <img src="../../../../assets/svg/calendly.svg" alt="Calendly logo" class="head-img">
                        <div>
                            <div class="title">{{translate?.setup.users.users.fields.integratesCalendly.singular}}</div>
                            <p class="sub">{{translate?.setup.users.users.descriptions.connectToCalendly.singular}}</p>
                        </div>
                    </div>
                    <div class="mp-toggle-meta">
                        <div class="mp-subhead-toggle">
                            <p-button
                                *ngIf="!calendlyCalenderConnected"
                                styleClass="text-nowrap connect"
                                [disabled]="!canConnectGoogleCalender"
                                [label]="translate?.general.buttons.connect.singular"
                                (onClick)="connectCalendlyCalender()"></p-button>
                            <p-button
                                *ngIf="calendlyCalenderConnected"
                                styleClass="text-nowrap connect p-button-danger"
                                [disabled]="!canConnectGoogleCalender"
                                [label]="translate?.general.buttons.disconnect.singular"
                                (onClick)="disConnectCalendlyCalender()"></p-button>
                        </div>
                    </div>
                </div>
            </section>
        </div>

        <div class="p-3" *ngIf="!hasAnyIntegrationEnabled">
            <span class="text-12">
                {{translate?.setup.users.users.messages.noIntegrationsEnabled}}&nbsp;{{translate?.setup.users.users.messages.goTo}}&nbsp;
                <a class="color-primary" href="javascript:void(0)" (click)="onClickIntegrations()">
                    {{ translate?.setup.users.access.sections.sec9.singular }}
                </a>&nbsp;{{translate?.setup.users.users.messages.toSetUpOrContactAdmin}}
            </span>
        </div>
    </div>
    <div class="flx-modal__footer">
        <button class="custella-btn-white" (click)="modalRef.hide()">
            {{ translate?.general.buttons.close.singular || 'Close' }}
        </button>
    </div>
</div>
